import styled from 'styled-components';

export const CustomForm = styled.form`
  .input-container {
    margin-bottom: 2em;
  }
`;
